<template>
	<div>
		<app-subheader>
			<v-layout align-center row wrap>
				<v-flex xs12 md3>
					<commerce-info
						:commerce="commerce"
					></commerce-info>
				</v-flex>
				<v-flex xs12 md5 class="border-left">
					<input-searcher
						color-new-primary
						placeholder="Buscar Productos"
						prepend-icon="search"
						v-model="searcher"
					></input-searcher>
				</v-flex>
			</v-layout>
		</app-subheader>
		<div class="detail-body container">
			<v-layout row wrap>
				<v-flex xs12 md5>
					<detail-gallery
						:images="productDetail.images"
						@select-image="selectImage"
					></detail-gallery>
				</v-flex>
				<v-flex xs12 md7 class="detail-body-right">
					<detail-info
						:detail="productDetail"
						:currency="currency"
						@add-quantity="addQuantity"
						@change-value="changeValue"
						@sub-quantity="subQuantity"
					></detail-info>
				</v-flex>
			</v-layout>
		</div>
		<related-products
			:currency="currency"
			:related-products="relatedProductsItems"
			:translate-value="translateValue"
			@add-quantity="addQuantity($event, true)"
			@change-value="changeValue($event, true)"
			@drag="dragEvent"
			@sub-quantity="subQuantity($event, true)"
		></related-products>
		<bar-info-actions
			:actions="actions"
		></bar-info-actions>
	</div>
</template>

<script>
	import appSubheader from '@/components/market-place/app-subheader';
	import barInfoActions from '@/components/market-place/bar-info-actions';
	import commerceInfo from '@/components/market-place/commerce-info';
	import detailGallery from '@/components/market-place/product-detail/detail-gallery';
	import detailInfo from '@/components/market-place/product-detail/detail-info';
	import inputSearcher from '@/components/shared/input-searcher';
	import relatedProducts from '@/components/market-place/product-detail/related-products';

	function created() {
		this.productDetail.images = this.productDetail.images.map((image) => {
			const newImage = { ...image };
			newImage.visible = !!image.flagMain;
			return newImage;
		});
	}

	function addQuantity(row, related) {
		if (related) {
			this.$set(row, 'quantity', row.quantity + 1);
		} else {
			this.productDetail.quantity += 1;
		}
	}

	function changeValue({ target }, row, related) {
		const { value } = target;
		if (value) {
			const newValue = Number(value) > 0 ? Number(value).toFixed() : 1;
			if (related) {
				this.$set(row, 'quantity', newValue);
			} else {
				this.productDetail.quantity = newValue;
			}
		} else {
			this.productDetail.quantity = 1;
		}
	}

	function dragEvent({ offsetX }) {
		const relatedProductsTag = document.getElementById('related-products');
		const tagSize = relatedProductsTag.offsetWidth;
		const itemsShow = (tagSize / 242).toFixed();
		const relatedProductsLength = this.relatedProductsItems.length;
		const addTranslation = this.translateValue !== 0;
		const validSubTranslation = itemsShow === relatedProductsLength;
		const subTranslation = this.translateValue < ((relatedProductsLength - 3) * 242);
		if (offsetX > 0) {
			if (addTranslation) {
				this.translateValue += 242;
			}
		} else if (validSubTranslation && subTranslation) {
			this.translateValue -= 242;
		}
	}

	function selectImage({ id }) {
		this.productDetail.images = this.productDetail.images.map((image) => {
			const newImage = { ...image };
			newImage.visible = image.id === id;
			return newImage;
		});
	}

	function subQuantity(row, related) {
		if (related) {
			this.$set(row, 'quantity', row.quantity - 1);
		} else if (this.productDetail.quantity > 1) {
			this.productDetail.quantity -= 1;
		}
	}

	function data() {
		return {
			actions: [
				{
					id: 1,
					icon: 'help_outline',
					link: '#',
					message: 'Si tienes alguna duda ingresa aquí',
					title: 'Cómo Comprar',
				},
				{
					id: 2,
					link: '#',
					message: 'Conoce tu tienda más cercana',
					title: 'Tiendas',
					urlImage: '/static/images-new/icons/icon-store.svg',
				},
				{
					id: 3,
					icon: 'local_shipping',
					link: '#',
					message: 'Conoce nuestros métodos de envío',
					title: 'Servicios de entrega',
				},
				{
					id: 4,
					icon: 'credit_card',
					link: '#',
					message: 'Conoce nuestros medios de pago',
					title: 'Medios de pago',
				},
			],
			commerce: {
				id: 1,
				distance: '3km',
				logo: '/static/images-new/logos/logo-store-default.png',
				name: 'Nombre de tienda',
			},
			currency: 'S/',
			productDetail: {
				id: 1,
				brand: {
					id: 1,
					name: 'Costeño',
				},
				brandName: 'Costeño',
				code: '76584758',
				images: [
					{
						id: 1,
						flagMain: 1,
						urlImage: '/static/images-new/sections/product-image-1.jpg',
					},
					{
						id: 2,
						flagMain: 0,
						urlImage: '/static/images-new/sections/product-image-2.webp',
					},
				],
				name: 'Arroz Extra Costeño',
				price: 18.9,
				quantity: 1,
				unitName: 'Bolsa 5 Kg',
			},
			relatedProductsItems: [
				{
					id: 1,
					brandName: 'Alpa',
					name: 'Aceite Alpa',
					price: 18.9,
					quantity: 1,
					unitName: 'Galonera',
					urlImage: '/static/images-new/sections/related-products-1.jpg',
				},
				{
					id: 2,
					brandName: 'Dulfina',
					name: 'Azúcar Dulfina',
					price: 18.9,
					quantity: 1,
					unitName: 'Bolsa 2 Kg',
					urlImage: '/static/images-new/sections/related-products-2.jpg',
				},
				{
					id: 3,
					brandName: 'Costeño',
					name: 'Arroz Extra Costeño',
					price: 18.9,
					quantity: 1,
					unitName: 'Bolsa 5 Kg',
					urlImage: '/static/images-new/sections/related-products-3.jpg',
				},
				{
					id: 4,
					brandName: 'Costeño',
					name: 'Maíz Costeño',
					price: 18.9,
					quantity: 1,
					unitName: 'Bolsa 1 Kg',
					urlImage: '/static/images-new/sections/related-products-4.jpg',
				},
				{
					id: 5,
					brandName: 'Don Vittorio',
					name: 'Spaghetti Vittorio',
					price: 18.9,
					quantity: 1,
					unitName: 'Bolsa 600 gr',
					urlImage: '/static/images-new/sections/related-products-5.jpg',
				},
			],
			searcher: '',
			translateValue: 0,
		};
	}

	export default {
		name: 'page-product-detail',
		components: {
			appSubheader,
			barInfoActions,
			commerceInfo,
			detailGallery,
			detailInfo,
			inputSearcher,
			relatedProducts,
		},
		created,
		data,
		methods: {
			addQuantity,
			changeValue,
			dragEvent,
			selectImage,
			subQuantity,
		},
		props: {
			product: [String, Number],
		},
	};
</script>

<style lang="scss" scoped>
	.border-left {
		border-top: 1px solid color(newprimary);
		margin-top: 18px;
		padding-top: 18px;

		@media (min-width: 936px) {
			border-left: 1px solid color(newprimary);
			border-top: 0px;
			margin-top: 0px;
			padding-left: 18px;
			padding-top: 0px;
		}
	}

	.detail-body {
		margin-bottom: 28px;

		@media (min-width: 936px) {
			margin-bottom: 88px;
			margin-top: 62px;
		}

		&-right {
			margin-top: 20px;

			@media (min-width: 936px) {
				margin-top: 70px;
				padding-left: 80px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/market-place/page-product-detail.vue